import { render, staticRenderFns } from "./detail-partial-storage-space.vue?vue&type=template&id=90e2c354"
import script from "./detail-partial-storage-space.vue?vue&type=script&lang=js"
export * from "./detail-partial-storage-space.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports